import { DefaultUrlSerializer, UrlTree } from '@angular/router';
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
      if(url.includes('assist-journey/confirm-details'))
      {
        return super.parse(url);
      }
      return super.parse(url.toLowerCase());
    }
}